import _ from "lodash";
import React from "react";
import { useIntl } from "react-intl";

export const NumberStringArrayValues = (props) => {
  const { values = [], changeValues } = props;
  const intl = useIntl();
  return (
    <div>
      {_.map(values, (elem, index) => {
        return (
          <div className="row mb-1" key={index}>
            <div className="col-3">
              <input
                type="text"
                name="value"
                className="form-control"
                placeholder={intl.formatMessage({ id: "value" })}
                value={elem.value || ""}
                onChange={({ target }) => {
                  Object.assign(values[index], { value: target.value });
                  changeValues(values);
                }}
              />
            </div>

            <div className="col-3">
              <input
                type="text"
                name="text"
                className="form-control"
                placeholder={intl.formatMessage({ id: "text" })}
                value={elem.text || ""}
                onChange={({ target }) => {
                  Object.assign(values[index], { text: target.value });
                  changeValues(values);
                }}
              />
            </div>

            <div className="col-5">
              <input
                type="text"
                name="url"
                className="form-control"
                placeholder={intl.formatMessage({ id: "url" })}
                value={elem.url || ""}
                onChange={({ target }) => {
                  Object.assign(values[index], { url: target.value });
                  changeValues(values);
                }}
              />
            </div>

            <div className="col text-right">
              <NumberStringArrayValues.RemoveButton {...props} index={index} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

NumberStringArrayValues.AddButton = (props) => {
  const { values = [], changeValues } = props;
  const addValueHandler = () => {
    changeValues(values.concat([{ value: null, text: null }]));
  };
  return (
    <button className={`btn btn-success ${props.className}`} onClick={addValueHandler}>
      <i className="fa fa-plus" />
    </button>
  );
};

NumberStringArrayValues.RemoveButton = (props) => {
  const { values = [], changeValues } = props;
  const removeValueHandler = () => {
    const newValues = values.filter((elem, index) => index !== props.index);
    console.log("index", props.index, { values, newValues });
    changeValues(newValues);
  };
  return (
    <button className={`btn btn-sm btn-danger`} onClick={removeValueHandler}>
      <i className="fa fa-minus" />
    </button>
  );
};

export default NumberStringArrayValues;
